import type {SuggestObject} from '@yandex-delivery/api/model/suggest'
import {makeGet} from '@yandex-delivery/utils'

import {
  type AddressPin,
  type SimpleAddressPin,
  type UserAddressPin,
  isUserAddressPin,
} from '../../../models/pickup-route'

export function toSimpleAddressPin(obj: SuggestObject): SimpleAddressPin {
  return {
    __type: 'simple-address-pin',
    coordinates: getPosition(obj),
    title: getTitle(obj),
    subtitle: getSubtitle(obj),
    city: getCity(obj),
  }
}

export function toUserAddressPin(
  obj: SuggestObject | AddressPin,
): UserAddressPin {
  if ('__type' in obj) {
    if (isUserAddressPin(obj)) {
      return obj
    }

    return {
      __type: 'user-address-pin',
      coordinates: obj.coordinates,
      title: obj.title,
      subtitle: obj.subtitle,
      city: obj.city,
    }
  }

  return {
    __type: 'user-address-pin',
    coordinates: getPosition(obj),
    title: getTitle(obj),
    subtitle: getSubtitle(obj),
    city: getCity(obj),
    trail: getTrail(obj),
  }
}

const suggestGetter = makeGet<SuggestObject>()
const getPosition = suggestGetter('position')
const getTitle = suggestGetter('title.text')
const getSubtitle = suggestGetter('subtitle.text')
const getCity = suggestGetter('city')
const getTrail = suggestGetter('distance.text')
